import { useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useSwipeNavigation = () => {
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();

  const minSwipeDistance = 50;

  const handleSwipe = useCallback((direction) => {
    const routes = [
      '/home-my-cards',
      '/home-my-holder', 
      '/home-web-holder'
    ];
    
    const currentIndex = routes.indexOf(location.pathname);
    
    if (direction === 'left' && currentIndex < routes.length - 1) {
      navigate(routes[currentIndex + 1]);
    } else if (direction === 'right' && currentIndex > 0) {
      navigate(routes[currentIndex - 1]);
    }
  }, [location.pathname, navigate]);

  const onTouchStart = useCallback((e) => {
    touchStartX.current = e.touches[0].clientX;
  }, []);

  const onTouchMove = useCallback((e) => {
    touchEndX.current = e.touches[0].clientX;
  }, []);

  const onTouchEnd = useCallback(() => {
    if (!touchStartX.current || !touchEndX.current) return;

    const distance = touchStartX.current - touchEndX.current;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      handleSwipe('left');
    } else if (isRightSwipe) {
      handleSwipe('right');
    }

    touchStartX.current = 0;
    touchEndX.current = 0;
  }, [handleSwipe]);

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd
  };
};